import { jsx as _jsx } from "react/jsx-runtime";
import { rusPhoneCode } from '../../constants/constants';
import { employeeTids } from '../../constants/tids';
import { FieldWrapper } from '../FieldWrapper';
import { TrimmedInput } from '../TrimmedInput';
export const PhoneField = ({ value, required, onValueChange, validationInfo, label = 'Телефон', }) => {
    const handleValueChange = (data) => {
        const trimmedData = data.replace(/\s/g, '');
        onValueChange(trimmedData === rusPhoneCode ? '' : trimmedData);
    };
    const handlePaste = (e) => {
        let candidate = e.clipboardData.getData('text').replace(/\D/g, '');
        const phoneLength = 10;
        if (candidate.length > phoneLength) {
            e.preventDefault();
            candidate = candidate.replace(/^(\+7|7|8)/, '').substring(0, phoneLength);
            onValueChange(`${rusPhoneCode}${candidate}`);
        }
    };
    return (_jsx(FieldWrapper, { label: label, children: _jsx(TrimmedInput, { width: 140, value: value, removeAllSpace: true, required: required, onPaste: handlePaste, mask: "+7 999 999 99 99", validationInfo: validationInfo, onValueChange: handleValueChange, "data-tid": employeeTids.phoneInput, placeholder: "+7" }) }));
};
